<template>
  <div>
    <el-form :model="form" :disabled="onlyInfo" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
      <el-row :gutter="20">
        <el-col :span="8" :offset="0">
          <el-form-item prop="code">
            <el-input label="Item Code" v-model.trim="form.code" maxlength="10" show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6" :offset="0">
          <el-form-item prop="vendorId">
            <el-select v-model="form.vendorId" placeholder="Vendor" clearable filterable style="width: 100%;">
              <el-option v-for="item in vendors"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="8" :offset="0">
          <el-form-item prop="name">
            <el-input label="Item Name" v-model="form.name" maxlength="100" show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="0">
          <el-form-item prop="unitId">
            <el-select v-model="form.unitId" placeholder="Units of Measure" clearable filterable style="width: 100%;">
              <el-option v-for="item in units"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <h4 style="margin-bottom: 5px;">Purchasing Details</h4>
      <h5 style="margin-top: 0; text-decoration: underline;">Asset</h5>

      <el-row :gutter="20">
        <el-col :span="8" :offset="0">
          <el-form-item prop="inventoryAssetAccountId">
            <el-select v-model="form.inventoryAssetAccountId" placeholder="Inventory Asset Account" clearable filterable style="width: 100%;">
              <el-option v-for="item in inventoryAccounts"
                :disabled="item.disable"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <h4 style="margin-bottom: 5px;">Selling Details</h4>
      <h5 style="margin-top: 0; text-decoration: underline;">Expenditure</h5>

      <el-row :gutter="20">
        <el-col :span="5" :offset="0">
          <el-form-item prop="purchasePrice">
            <!-- <el-input label="Cost Price" type="number" v-model.trim="form.purchasePrice"></el-input> -->
            <money v-model="form.purchasePrice" :disabled="onlyInfo" v-bind="money" prefix="Std Cost: "></money>
          </el-form-item>
        </el-col>
        <el-col :span="11" :offset="0">
          <el-form-item prop="purchaseAccountId">
            <el-select v-model="form.purchaseAccountId" placeholder="COGS Account" clearable filterable style="width: 100%;">
              <el-option v-for="item in purchaseAccounts"
                :disabled="item.disable"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="0">
          <el-form-item prop="purchaseTaxAccountId">
            <el-select v-model="form.purchaseTaxAccountId" placeholder="Tax Rate" clearable filterable style="width: 100%;">
              <el-option v-for="item in purchaseTaxAccounts"
                :disabled="item.disable"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <h4 style="margin: 0; font-weight: normal">Purchase Description</h4>

      <el-form-item prop="purchaseDescription">
        <el-input label="Description" type="textarea" v-model="form.purchaseDescription" maxlength="200" show-word-limit></el-input>
      </el-form-item>

      <h5 style="margin-top: 0; text-decoration: underline;">Revenue</h5>

      <el-row :gutter="20">
        <el-col :span="5" :offset="0">
          <el-form-item prop="sellPrice">
            <!-- <el-input label="Sell Price" type="number" v-model.trim="form.sellPrice"></el-input> -->
            <money v-model="form.sellPrice" :disabled="onlyInfo" v-bind="money" prefix="Sell Price: "></money>
          </el-form-item>
        </el-col>
        <el-col :span="11" :offset="0">
          <el-form-item prop="sellAccountId">
            <el-select v-model="form.sellAccountId" placeholder="Revenue Account" clearable filterable style="width: 100%;">
              <el-option v-for="item in sellAccounts"
                :disabled="item.disable"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="0">
          <el-form-item prop="sellTaxAccountId">
            <el-select v-model="form.sellTaxAccountId" placeholder="Tax Rate" clearable filterable style="width: 100%;">
              <el-option v-for="item in sellTaxAccounts"
                :disabled="item.disable"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <h4 style="margin: 0; font-weight: normal">Selling Description</h4>

      <el-form-item prop="sellDescription">
        <el-input label="Description" type="textarea" v-model="form.sellDescription" maxlength="200" show-word-limit></el-input>
      </el-form-item>

      <el-table
        :data="tableData"
        size="mini"
        border
        style="margin-bottom: 10px; width: 100%;">
        <el-table-column
          label="Item Code">
          <template slot-scope="scope">
            <el-select v-model="scope.row.code" filterable size="mini" placeholder="Select" style="width:100%">
              <el-option v-for="item in items"
                :key="item.id"
                :label="item.code"
                :value="item.code"
                @click.native="selectItemCode(item, scope.row)">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="Item Name">
          <template slot-scope="scope">
            <el-select v-model="scope.row.name" filterable size="mini" placeholder="Select" style="width:100%">
              <el-option v-for="item in items"
                :key="item.id"
                :label="item.name"
                :value="item.name"
                @click.native="selectItemName(item, scope.row)">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="Description"
          align="center">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.description"
              placement="top"
              title="Description"
              width="400"
              trigger="click"
              :content="scope.row.description">
              <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="Cost"
          align="right">
          <template slot-scope="scope">
            <div v-if="scope.row.purchasePrice" v-text="formatPrice(scope.row.purchasePrice)"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="Sell"
          align="right">
          <template slot-scope="scope">
            <div v-if="scope.row.sellPrice" v-text="formatPrice(scope.row.sellPrice)"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="QTY"
          align="center"
          width="70">
          <template slot-scope="scope">
            <el-input placeholder="Qty" type="number" v-model="scope.row.count" size="mini" @input="countTotal(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="unitName"
          label="UoM"
          align="center">
        </el-table-column>
        <el-table-column
          label="Total Coast"
          align="right">
          <template slot-scope="scope">
            <div v-text="formatPrice(scope.row.purchaseTotal)"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="Total Sell"
          align="right">
          <template slot-scope="scope">
            <div v-text="formatPrice(scope.row.sellTotal)"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="Action"
          align="left"
          width="151">
          <template slot-scope="scope">
            <div>
              <el-button
                v-if="scope.$index !== 0"
                size="mini"
                type="primary"
                plain
                @click="addNewItem(scope.$index, scope.row)">Add line</el-button>
              <el-button
                v-if="(scope.$index !== 0) && (scope.$index !== 1)"
                size="mini"
                type="danger"
                icon="el-icon-delete"
                plain
                @click="removeItem(scope.$index, scope.row)"></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="total">
        <div class="total__purchase">{{ formatPrice(purchaseTotal) }}</div>
        <div class="total__sell">{{ formatPrice(sellTotal) }}</div>
      </div>

      <el-form-item v-if="!onlyInfo">
        <div class="btn__flex-end">
          <div v-if="isCreate">
            <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
            <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
          </div>
          <div v-else>
            <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
            <el-button @click="editItem('form')" type="primary">{{$t('general_submit')}}</el-button>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import {Money} from 'v-money'

  export default {
    name: 'group',
    components: {
      SweetModal,
      Money,
    },
    props: ['typeId'],
    data() {
      return {
        money: {
          precision: 2,
          decimal: '.',
          thousands: ',',
          masked: false
        },

        isCreate: true,
        row: null,
        onlyInfo: false,

        purchaseAccounts: [],
        purchaseTaxAccounts: [],
        sellAccounts: [],
        sellTaxAccounts: [],
        inventoryAccounts: [],
        units: [],
        vendors: [],

        form: {
          code: '',
          name: '',
          unitId: null,
          // vendorId: null,
          // Purchasing Details
          inventoryAssetAccountId: null,
          // Selling Details
          purchasePrice: null,
          purchaseAccountId: null,
          purchaseTaxAccountId: null,
          purchaseDescription: '',
          sellPrice: null,
          sellAccountId: null,
          sellTaxAccountId: null,
          sellDescription: '',

          reorderQtyMin: null,
          reorderQtyMax: null,
        },

        items: [],
        purchaseTotal: 0,
        sellTotal: 0,
        tableData: [
          {
            itemId: null,
            code:null,
            name:null,
            description: null,
            purchasePrice: 0,
            sellPrice: 0,
            count: 1,
            unitName: null,
            purchaseTotal: 0,
            sellTotal: 0,
          },
          {
            itemId: null,
            code:null,
            name:null,
            description: null,
            purchasePrice: 0,
            sellPrice: 0,
            count: 1,
            unitName: null,
            purchaseTotal: 0,
            sellTotal: 0,
          },
        ],

        rules: {
          code: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          unitId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          // Purchasing Details
          inventoryAssetAccountId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          // Selling Details
          purchasePrice: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          purchaseAccountId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          purchaseTaxAccountId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          purchaseDescription: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          sellPrice: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          sellAccountId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          sellTaxAccountId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'change' }
          ],
          sellDescription: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
        },
      }
    },
    watch: {
      tableData: {
        handler(newVal, oldVal) {
          this.purchaseTotal = 0
          this.sellTotal = 0
          newVal.forEach((element) => {
            this.purchaseTotal += element.purchaseTotal
            this.sellTotal += element.sellTotal
          });
          this.form.purchasePrice = this.purchaseTotal
          this.form.sellPrice = this.sellTotal
        },
        deep: true
      },
    },
    methods: {
      async openModal({ isCreate = true, row = {}, onlyInfo = false }) {
        this.onlyInfo = onlyInfo
        this.isCreate = isCreate
        this.row = row
        await this.getDirectories()
        if (!isCreate) {
          await this.handleEdit()
        }
      },
      modalCancel(ref) {
        this.$emit('modalCancel', ref)
      },
      async getDirectories() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/items/directories?companyId=${this.$route.query.companyId}&typeId=${this.typeId}`)
          console.log("🚀 ~ file: CreateUpdateModal.vue:108 ~ directories ~ data:", data)
          this.purchaseAccounts = data.directories.purchaseAccounts
          this.purchaseTaxAccounts = data.directories.purchaseTaxAccounts
          this.sellAccounts = data.directories.sellAccounts
          this.sellTaxAccounts = data.directories.sellTaxAccounts
          this.inventoryAccounts = data.directories.inventoryAccounts
          this.units = data.directories.units
          this.vendors = data.directories.vendors
          this.items = data.directories.items
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      async checkPrice() {
        return (this.form.sellPrice < this.form.purchasePrice) ? true : false
      },
      addItem(form) {
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            if (await this.checkPrice()) {
              this.$confirm('Sell price less than Purchase, confirm if it’s correct. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'info'
              }).then(() => {
                this.addItemRequest()
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: 'Create canceled'
                });
              });
            } else {
              this.addItemRequest()
            }
          } else {
            console.log('Error valid!');
            return false;
          }
        });
      },
      async addItemRequest() {
        let loader = this.$loading.show();
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          arr.push({ itemId: this.tableData[i].itemId, count: +this.tableData[i].count, purchaseTotal: this.tableData[i].purchaseTotal, sellTotal: this.tableData[i].sellTotal })
        }
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          await axios.post(`/api/v1/items?companyId=${this.$route.query.companyId}`, {
            ...this.form, itemsTypeId: this.typeId, group: arr, purchase: true, sell: true
          })
          this.modalCancel('modal')
          this.$emit('loadList')
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      async handleEdit() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/items?id=${this.row.id}`)
          for (const key in this.form) {
            this.form[key] = data.item[key]
          }
          this.tableData = data.item.itemsGroup
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      editItem(form) {
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            if (await this.checkPrice()) {
              this.$confirm('Sell price less than Purchase, confirm if it’s correct. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'info'
              }).then(() => {
                this.editItemRequest()
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: 'Create canceled'
                });
              });
            } else {
              this.editItemRequest()
            }
          } else {
            console.log('Error valid!');
            return false;
          }
        });
      },
      async editItemRequest() {
        let loader = this.$loading.show();
        let arr = []
        for (let i = 0; i < this.tableData.length; i++) {
          arr.push({ itemId: this.tableData[i].itemId, count: +this.tableData[i].count, purchaseTotal: this.tableData[i].purchaseTotal, sellTotal: this.tableData[i].sellTotal })
        }
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          await axios.put(`/api/v1/items?id=${this.row.id}`, {
            ...this.form, itemsTypeId: this.typeId, group: arr, purchase: true, sell: true
          })
          this.modalCancel('modal')
          this.$emit('loadList')
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      removeItem(index, row) {
        this.tableData = this.tableData.filter((_, i) => i !== index);
      },
      selectItemCode(item, row) {
        row.name = item.name
        row.itemId = item.itemId
        row.description = item.description
        row.purchasePrice = item.purchasePrice
        row.sellPrice = item.sellPrice
        row.unitName = item.unitName
        row.count = 1
        row.purchaseTotal = item.purchasePrice
        row.sellTotal = item.sellPrice
        return row
      },
      selectItemName(item, row) {
        row.code = item.code
        row.itemId = item.itemId
        row.description = item.description
        row.purchasePrice = item.purchasePrice
        row.sellPrice = item.sellPrice
        row.unitName = item.unitName
        row.count = 1
        row.purchaseTotal = item.purchasePrice
        row.sellTotal = item.sellPrice
        return row
      },
      addNewItem(index, row) {
        const item = {
          itemId: null,
          code:null,
          name:null,
          description: null,
          purchasePrice: 0,
          sellPrice: 0,
          count: 1,
          unitName: null,
          purchaseTotal: 0,
          sellTotal: 0,
        }

        this.tableData.push(item)
        return row
      },
      countTotal(row) {
        if (row.count) {
          row.purchaseTotal = row.count * row.purchasePrice
          row.sellTotal = row.count * row.sellPrice
        } else {
          row.purchaseTotal = 0
          row.sellTotal = 0
        }
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
    },
  }
</script>

<style lang="scss" scoped>
.total {
  font-size: 12px;
  margin-bottom: 20px;
  padding-left: 607px;
  &__purchase {
    text-align: right;
    padding: 0 10px;
    width: 89px;
    display:inline-block;
    width: 89px;
  }
  &__sell {
    text-align: right;
    padding: 0 10px;
    width: 89px;
    display:inline-block;
    width: 89px;
  }
}

/deep/.v-money {
  height: 40px;
  line-height: 40px;
  -webkit-appearance: none;
  background-color: transparent;
  background-image: none;
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.5);;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px 0 0;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
}
</style>